import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  quantity: () => __(translations.commercialDocumentComponents.quantity, 'Quantity'),
  component: () => __(translations.commercialDocumentComponents.component, 'Component'),
};
